module.exports = __webpack_public_path__ + "static/media/GH1.c9deac4d.jpg";